import { Controller } from 'react-hook-form'

import PatientFormField from '../PatientFormField'
import { useFormContextPatient, validateUnrequiredStringValue } from '../_utils'

const Room = () => {
    const { control } = useFormContextPatient()

    return (
        <Controller
            control={control}
            name="room"
            rules={{
                minLength: 0,
                validate: validateUnrequiredStringValue,
            }}
            render={({ field, fieldState: { error } }) => (
                <PatientFormField
                    variant="input"
                    dataCyScope="PatientField"
                    label="Numéro de chambre"
                    status={{
                        error,
                        valid: Boolean(field.value),
                    }}
                    size="1"
                    {...field}
                    value={field.value ?? ''}
                    placeholder="Numéro de chambre"
                />
            )}
        />
    )
}

export default Room
